import { createIntl, createIntlCache, IntlShape } from 'react-intl';
import { getIntlLocale, getMessages } from 'i18n/messages';

/**
 * Message ids not present in the active locale dictionary fall back to their
 * inline English defaultMessage by design (localized JSON lags source keys
 * until the next Lokalise sync), so MISSING_TRANSLATION is expected noise.
 */
const handleIntlError = (err: { code?: string }) => {

    if (err?.code === 'MISSING_TRANSLATION') return;
    console.error(err);

};

const intlCache = createIntlCache();

const buildIntl = (cultureTag: string): IntlShape => createIntl({
    defaultLocale: 'en-US',
    locale: getIntlLocale(cultureTag),
    messages: getMessages(cultureTag),
    onError: handleIntlError
}, intlCache);

// Module-level intl for code that runs outside the React tree (module-scope
// helpers, pre-provider bootstrap errors). Kept in sync by LocalizedIntlProvider.
let appIntl: IntlShape = buildIntl('en-US');

export const getAppIntl = (): IntlShape => appIntl;

/** Rebuild and store the shared intl for a culture. Called by LocalizedIntlProvider. */
export const syncAppIntl = (cultureTag: string): IntlShape => {

    appIntl = buildIntl(cultureTag);
    return appIntl;

};
